export default "__VITE_ASSET__a7b23fbe__"